import ReviewSubmittals from "./ReviewSubmittals";

export default ReviewSubmittals;
